import axios from 'axios';
import { authUrl } from '../config/constants';
import storage from 'utils/storage';

export default {
  // trusted_device_token lets a browser remembered after an emailed sign-in
  // code skip the code (RM-3849).
  signInUser: async ({email, password}: {email: string; password: string}) => {
    const trusted_device_token = storage.get('trusted-device-token') ?? undefined;
    const res = await axios.post(`${authUrl}/sign_in`, {email, password, trusted_device_token});
    return res;
  },
  verifyLoginCode: async ({challengeToken, code, rememberDevice}: {challengeToken: string; code: string; rememberDevice: boolean}) => {
    const res = await axios.post(`${authUrl}/login_code/verify`, {
      challenge_token: challengeToken,
      code,
      remember_device: rememberDevice,
    });
    return res;
  },
  resendLoginCode: async (challengeToken: string) => {
    const res = await axios.post(`${authUrl}/login_code/resend`, { challenge_token: challengeToken });
    return res;
  },
  validateUser: async () => {
    const params = {
      'access-token': storage.get('access-token'),
      client: storage.get('client'),
      uid: storage.get('uid'),
    }
    const res = await axios.get(`${authUrl}/validate_token`, { params });

    // const json = localStorage.getItem('history');
    // const history = json ? JSON.parse(json) : []
    // history.push(res.headers['access-token']);
    // localStorage.setItem('history', JSON.stringify(history));

    storage.set('access-token', res.headers['access-token']);
    storage.set('client', res.headers['client']);
    storage.set('uid', res.headers['uid']);

    return res;
  }
};
